
export const CareerJobConverter: { [x: string]: string } = {
  "Code": "Categroy Name",
  "TEBE": "Backend Development",
  "CCW": "Copywriting",
  "CRE": "Creative",
  "CSR": "Customer Service",
  "TECD": "Data Science & Analytics",
  "CDE": "Design",
  "ECO": "Early career opportunities",
  "GFP": "EF Global Finance Program",
  "GMP": "EF360 Global Management Trainee Program",
  "ENS": "Entrepreunerial Sales Development Program",
  "FAC": "Faculty",
  // "FAC": "Faculty & Research",
  "FBI": "Finance & Business Intelligence",
  "FLB": "Finance, Legal & Business Intelligence",
  "TECF": "Frontend Development",
  "GMA": "General Management & Administration",
  "INT": "Internships",
  // "INT": "Recent Graduates & Internships",
  "TECL": "Leadership",
  "MAR": "Marketing",
  "TECM": "Mobile Development",
  "NA": "Not Applicable",
  "OCS": "Operations",
  // "OCS": "Operations & Customer Service",
  "TECP": "Product Management",
  "CPR": "Production",
  "TECQ": "Quality Assurance",
  "SAE": "Sales",
  "SAL": "Sales & Marketing",
  "SOP": "Seasonal Opportunities",
  "TECS": "Security & Admin",
  "TAB": "Teach Abroad",
  // "TAB": "Teach English Abroad",
  "THS": "Teach at High Schools",
  "TON": "Teach English Online",
  "TLT": "Teach Locally Long Term",
  "TST": "Teach Locally Short Term",
  "TEA": "Teaching",
  "TAD": "Teaching Administration",
  "TEC": "Technology",
  "GRA": "Trainee programs and Internships",
  "CUX": "User Experience Design"
}